import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="stat-toggle"
// Swaps the stats panel between Today and All-time by setting data-statview on
// the panel (CSS shows/hides the matching .sp-view + header chrome). Resets to
// Today on load — All-time is an on-demand glance, not a sticky default.
export default class extends Controller {
  show(event) {
    const view = event.currentTarget.dataset.view
    this.element.dataset.statview = view
    this.element.querySelectorAll(".seg-btn").forEach((b) => {
      const on = b.dataset.view === view
      b.classList.toggle("on", on)
      b.setAttribute("aria-selected", on ? "true" : "false")
    })
  }
}
